import React from 'react';
import {
  Box,
  Drawer,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CircularProgress
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FolderIcon from '@mui/icons-material/Folder';
import ClarityAnalytics from './clarity';

const ProjectDrawer = ({
  open,
  onClose,
  projects,
  isLoadingProjects,
  selectedProject,
  handleProjectSelect,
  creditsLoading,
  credits,
  isLoaded,
  user,
  onNewProject
}) => {
  return (
    <>
      <><ClarityAnalytics /></>
      <Drawer
        variant="temporary"
        open={open}
        onClose={onClose}
        sx={{
          "& .MuiDrawer-paper": {
            width: 320,
            boxSizing: "border-box",
            backgroundColor: "#1a1a1a",
            color: "white",
          },
        }}
      >
        <Box className="flex flex-col h-full">
          {/* Sidebar Header */}
          <Box className="p-4 border-b border-gray-700 flex items-center justify-between">
            <Typography variant="h6" className="text-white">
              Projects
            </Typography>
            <IconButton
              onClick={onNewProject}
              sx={{ color: "white" }}
            >
              <AddIcon />
            </IconButton>
          </Box>

          {/* Projects List */}
          <List className="flex-grow overflow-y-auto">
            {isLoadingProjects ? (
              <Box className="flex justify-center p-4">
                <CircularProgress size={24} sx={{ color: "white" }} />
              </Box>
            ) : projects?.length === 0 ? (
              <Box className="p-4 text-center text-gray-400">
                <Typography variant="body2">
                  No projects yet. Create one to get started.
                </Typography>
              </Box>
            ) : (
              projects
                ?.slice()
                .reverse()
                .map((project) => (
                  <ListItem
                    key={project.project_id}
                    button
                    selected={selectedProject === project.project_id}
                    onClick={() => {
                      handleProjectSelect(project.project_id);
                      onClose(); // Close drawer after selection
                    }}
                    sx={{
                      minHeight: 48,
                      px: 2.5,
                      color: "white",
                      "&.Mui-selected": {
                        backgroundColor: "#333",
                        "&:hover": {
                          backgroundColor: "#444",
                        },
                        borderLeft: "4px solid #818cf8",
                        transition: "all 0.2s ease-in-out",
                      },
                      "&:hover": {
                        backgroundColor: "#222",
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        color:
                          selectedProject === project.project_id
                            ? "#2b8ced"
                            : "white",
                        minWidth: 32,
                      }}
                    >
                      <FolderIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={project.project_name}
                      secondary={
                        <Typography
                          variant="caption"
                          sx={{
                            color:
                              selectedProject === project.project_id
                                ? "rgba(255,255,255,0.9)"
                                : "rgba(255,255,255,0.7)",
                          }}
                        >
                          {new Date(project.createdAt).toLocaleDateString()}
                        </Typography>
                      }
                      primaryTypographyProps={{
                        sx: {
                          fontWeight:
                            selectedProject === project.project_id
                              ? 600
                              : 400,
                        },
                      }}
                    />
                  </ListItem>
                ))
            )}
          </List>

          {/* Credits and Stripe Section */}
          <Box className="border-t border-gray-700 p-4">
            {creditsLoading ? (
              <Box className="flex justify-center">
                <CircularProgress size={20} sx={{ color: "white" }} />
              </Box>
            ) : (
              <Box className="text-center">
                <Typography variant="body2" className="text-gray-300">
                  Available Credits: {credits?.amount || 0}
                </Typography>
                {credits?.expiryDate && credits.amount > 0 && (
                  <Typography variant="caption" className="text-gray-400">
                    Expires in{" "}
                    {Math.ceil(
                      (new Date(credits.expiryDate) - new Date()) /
                      (1000 * 60 * 60 * 24)
                    )}{" "}
                    days
                  </Typography>
                )}
              </Box>
            )}

            {isLoaded && user && (
              <Box
                className="mt-4"
                sx={{
                  "& stripe-buy-button": {
                    display: "block",
                    width: "100%",
                    "--stripe-buy-button-theme-text-color": "#4f46e5",
                    "--stripe-buy-button-theme-background-color": "#ffffff",
                    "--stripe-buy-button-height": "40px",
                  },
                }}
              >
                <stripe-buy-button
                  buy-button-id="buy_btn_1Qd0NTJNqQqG6YgGYMIs4XtP"
                  publishable-key="pk_live_51K9B4oJNqQqG6YgG62UgijNg3QYZkjGP9C2SycPnUgqsCdfMxU59WsrNtD7zaEeNBAQbNCCAnTsXWyqZ0l8uHKYX006OqqSHF0"
                  customer-email={user.primaryEmailAddress?.emailAddress}
                  customer-metadata={JSON.stringify({
                    clerkUserId: user.id,
                    email: user.primaryEmailAddress?.emailAddress,
                  })}
                />
              </Box>
            )}
          </Box>
        </Box>
      </Drawer>
      </>
      );
};

      export default ProjectDrawer; 